import { IAstNode, IFunctionCallAstNode, IComposeFunc } from '../../typings/ast-node';
import { IToken, IFunctionToken } from '../../typings/token';
import { getCloseBracketTokenPosition } from '../../utils';
import { TokenComposeError } from '../../errors';
import { splitTokensWithComma } from '../utils';



export function composeFunctions(astNodes: IAstNode[], compose: IComposeFunc) {
  const index = astNodes.findIndex(({ type, token }) => {
    return type === 'Temporary' && !!token && token.type === 'Function';
  });
  if (index === -1) { return; }

  const tokens = astNodes.map(node => node.token) as IToken[];
  const functionToken = tokens[index] as IFunctionToken;
  const openParenthesisToken = tokens[index + 1];
  const end = getCloseBracketTokenPosition(index + 1, tokens, 'OpenParenthesis', 'CloseParenthesis');
  if (end === -1) {
    throw new TokenComposeError('parenthesis-not-closed', `函数 ${functionToken.formatName} 缺少结束括号`, openParenthesisToken.position);
  }
  const eatNodes = astNodes.slice(index, end + 1);
  const argsNodes = astNodes.slice(index + 2, end);
  const args = splitTokensWithComma(argsNodes);
  args.forEach((arg, index) => {
    if (!arg.length) {
      throw new TokenComposeError('invalid-function-argument', `函数 ${functionToken.formatName} 的第 ${index + 1} 个参数值不能为空`, openParenthesisToken.position);
    }
  });
  const token = astNodes[index].token as IFunctionToken;
  const children = args.map(arg => compose(arg));
  const node: IFunctionCallAstNode = {
    type: 'FunctionCall',
    token,
    value: token.code,
    args: children,
    children
  };
  astNodes.splice(index, eatNodes.length, node);
  composeFunctions(astNodes, compose);
}
